import { FORMAT } from "./constants"

export function extractFormat(s) {
    if (s) {
        const sa = s.toString().split(":")

        if (sa.length == 3) {
            return {
                format: sa[0],
                decimals: sa[1],
                emptyText: sa[2]
            }
        } else {
            return {
                format: s,
                decimals: 0,
                emptyText: '-'
            }
        }
    }

    return {
        format: null,
        decimals: 0,
        emptyText: '-'
    }
}

export function getFormatValue(format, value) {
    const ef = extractFormat(format)

    if (!value) return ef.emptyText

    if (ef.format == FORMAT.BYTE) {
        return toBytes(value, ef.decimals)
    } else if (ef.format == FORMAT.DATE) {
        return toThDate(value)
    } else if (ef.format == FORMAT.DATE_TIME) {
        return toThDateTime(value)
    } else if (ef.format == FORMAT.DECIMAL) {
        return toDecimal(value, ef.decimals)
    } else if (ef.format == FORMAT.INT) {
        return toInt(value)
    }

    return value
}

export function getFormat(format, decimals, emptyText) {
    return format + ":" + decimals + ":" + emptyText
}

export function isDate(v) {
    return v && typeof v !== 'undefined' && typeof v.getFullYear === "function"
}

export function toDate(val) {
    if (isDate(val)) {
        return val.toLocaleString('en-US', {
            month: 'short',
            day: 'numeric',
            year: 'numeric'
        })
    }
    else {
        const date = new Date(val)
        return date.toLocaleString('en-US', {
            month: 'short',
            day: 'numeric',
            year: 'numeric'
        })
    }
}

export function toThDate(val) {
    if (isDate(val)) {
        return val.toLocaleString('th-TH', {
            day: 'numeric',
            month: 'short',
            year: 'numeric'
        })
    }
    else {
        const date = new Date(val)
        return date.toLocaleString('th-TH', {
            day: 'numeric',
            month: 'short',
            year: 'numeric'
        })
    }
}

export function toDateTime(val) {
    if (isDate(val)) {
        return val.toLocaleString('en-US', {
            year: 'numeric',
            month: 'short',
            day: 'numeric',
            hour: '2-digit',
            minute: '2-digit'
        })
    } else {
        const date = new Date(val)

        return date.toLocaleString('en-US', {
            year: 'numeric',
            month: 'short',
            day: 'numeric',
            hour: '2-digit',
            minute: '2-digit'
        })
    }
}

export function toThDateTime(val) {
    if (isDate(val)) {
        return val.toLocaleString('th-TH', {
            day: 'numeric',
            month: 'short',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit'
        })
    } else {
        const date = new Date(val)
        return date.toLocaleString('th-TH', {
            day: 'numeric',
            month: 'short',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit'
        })
    }
}

export function toDateString(language, showTime, val) {
    if (showTime) {
        if (language == "en") {
            return toDateTime(val);
        } else {
            return toThDateTime(val);
        }
    } else {
        if (language == "en") {
            return toDate(val);
        } else {
            return toThDate(val);
        }
    }
}

export function toBytes(value, decimals) {
    if (!value) return '0 Bytes'
    if (isNaN(parseFloat(value)) && !isFinite(value)) return '0 Bytes'
    const k = 1024
    const dm = decimals < 0 ? 0 : decimals
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
    const i = Math.floor(Math.log(value) / Math.log(k))

    return (value / Math.pow(k, i)).toFixed(dm) + ' ' + sizes[i]
}

export function toDecimal(value, decimals) {
    const n = parseFloat((Math.round(value * 100) / 100).toFixed(decimals ? decimals : 2))
    return n.toLocaleString('en-US')
}

export function toInt(value) {
    return parseInt(value).toLocaleString('en-US')
}
